import React from "react"
import { Container } from "@components"
import { Box } from "rebass"
import data from "./Data"
import TutorialList from "./TutorialList"
import WithoutImageList from "./WithoutImageList"
import Headline from "@components/aggregation/Headline.js"
import Filter from "./Filter"

const Content = () => (
  <Container>
    <Box mt={[32, 62]}>
      <p>
        DynamoDB tools cover different jobs: GUIs inspect data, infrastructure
        tools define tables, and libraries help applications build requests and
        map items. Use the categories below to choose a tool for the task; old
        projects remain listed where they help maintain existing applications.
      </p>
      <Filter />
      <p>
        Choosing a database GUI? Compare Dynobase with the{" "}
        <a href="/aws-dynamodb-console-alternative/">AWS DynamoDB console</a> and{" "}
        <a href="/nosql-workbench-alternative/">NoSQL Workbench</a>.
      </p>
      <Headline headline={"Management"} id="management" />
      <TutorialList data={data.management} noJustify />

      <Headline headline={"Infrastructure as code"} id="iac" />
      <TutorialList data={data.iac} />

      <Headline headline={"Utility"} id="utility" />
      <TutorialList data={data.utility} />

      <Headline headline={"Local"} id="local" />
      <WithoutImageList data={data.local} />

      <Headline headline={"Backup, restore and data movement"} id="backup" />
      <p>
        Start with DynamoDB's managed <a href="/dynamodb-backup-and-restore/">backup and restore</a>{" "}
        or <a href="/dynamodb-point-in-time-recovery/">point-in-time recovery</a>{" "}
        for recovery, and <a href="/export-dynamodb-data-to-s3/">S3 export</a>{" "}
        for data files. The projects below include custom scripts and archived
        tools; a copy script or search index is not a substitute for a recovery plan.
      </p>
      <WithoutImageList data={data.backup} />

      <p>
        DynamoDB Toolbox provides typed request building and entity schemas;
        ElectroDB focuses on entities and access patterns for single-table
        designs. Dynamoose and PynamoDB offer model-oriented interfaces. These
        libraries do not add relational joins: your keys and indexes still
        determine which queries DynamoDB can serve efficiently. Check SDK
        compatibility and maintenance status before adopting a dependency. The{" "}
        <a href="/dynamodb-orm/">DynamoDB ORM comparison</a> runs the main
        JavaScript and TypeScript libraries against the same model.
      </p>
      <Headline headline={"Libraries: JavaScript"} id="libraries" />
      <WithoutImageList data={data.libraries.javascript} />

      <Headline headline={"Libraries: TypeScript"} id="libraries-typescript" />
      <WithoutImageList data={data.libraries.typescript} />

      <Headline headline={"Libraries: Python"} id="libraries-python" />
      <WithoutImageList data={data.libraries.python} />

      <Headline headline={"Libraries: Go"} id="libraries-golang" />
      <WithoutImageList data={data.libraries.golang} />

      <Headline headline={"Libraries: Ruby"} id="libraries-ruby" />
      <WithoutImageList data={data.libraries.ruby} />

      <Headline headline={"Libraries: PHP"} id="libraries-php" />
      <WithoutImageList data={data.libraries.php} />

      <Headline headline={"Libraries: C#"} id="libraries-dotnet" />
      <WithoutImageList data={data.libraries.dotnet} />
    </Box>
  </Container>
)

export default Content
